import React, { useEffect } from "react";

import Lottie from 'lottie-react';
import PageNotFoundAnimation from "../Assets/LottieFiles/404-animation.json";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import usePageMeta from "../Helpers/usePageMeta";

const NoPageFound = () => {
  usePageMeta({
    title: "404 - Page Not Found | TZ Creation",
    description: "The page you're looking for doesn't exist or has moved.",
    noindex: true,
  });
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: PageNotFoundAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  function AnimcatedComponent() {
    return <Lottie animationData={PageNotFoundAnimation} loop={true} options={defaultOptions} height={800} width={800} />;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <AnimcatedComponent />
      <Footer />
    </>
  );
};

export default NoPageFound;
